export const PLANNER_NAMES: { [plannerId: string]: string } = {
    'luke': 'Shared energy optimizer',
    'linear': 'Linear minimization of cost'
};

export const PLANNER_DESCRIPTIONS: { [plannerId: string]: string } = {
    'luke': 'Uses storage in order to maximize shared energy',
    'linear': 'Uses microgrid assets in order to minimize grid electricity and gas cost'
};
